import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./styles.css";

const ProjectsRow = ({ projects }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [projectRowIndex, setProjectRowIndex] = useState(0);

  if (!projects || projects.length === 0) {
    return null;
  }

  const visibleProjectsCount = Math.min(3, projects.length);
  const visibleProjects = Array.from({ length: visibleProjectsCount }, (_, offset) => {
    const index = (projectRowIndex + offset) % projects.length;
    return projects[index];
  });

  function handleNextProject() {
    setProjectRowIndex((prevIndex) => (prevIndex + 1) % projects.length);
  }

  return (
    <div className="lp-main-projects-slider-wrapper">
      <div className="lp-main-projects-slider">
        <div className="lp-main-projects-cards-container">
          {visibleProjects.map((project) => (
            <div
              key={project.slug}
              className="lp-main-project-display"
              onClick={() => navigate(`/projects/${project.slug}`)}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  navigate(`/projects/${project.slug}`);
                }
              }}
            >
              <img
                src={`${project.assetFolder}${project.assetLogo}`}
                alt={t(project.titleKey)}
                title={t(project.titleKey)}
              />
              <span className="lp-main-project-name">{t(project.titleKey)}</span>
            </div>
          ))}
        </div>

        <button
          type="button"
          className="lp-main-project-next-button"
          onClick={handleNextProject}
          aria-label={t("landingPage.about.projects.button")}
        >
          &gt;
        </button>
      </div>
    </div>
  );
};

export default ProjectsRow;
